export default __webpack_public_path__ + "static/media/animal_skull.a2968df3.jpg";